export default "__VITE_ASSET__e05bc85b__"